module.exports = __webpack_public_path__ + "fonts/Graphik-Extralight.7f1dae4a.ttf";